
export const APIKEY = 'Enter your API Key Here'
export const URL_PATH = 'Enter the URL provided by BarcodeLookup.com'
export const URL_EXTENSION = 'Enter the extension of the URL'